import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackClickedCreateAWorkspace = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedCreateAWorkspace = useCallback(() => {
    track(`Clicked create a workspace on approved domains`);
  }, [track]);

  return { trackClickedCreateAWorkspace };
};
